import {HighlightSlide} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/highlight.types';
import React from 'react';
import {useHighlightZoomSliderTracking} from './hooks/useHighlightZoomSliderTracking';

interface BrandHighlightCtaTrackedProps {
  position: number;
  highlightId: number;
  highlightSlide: HighlightSlide;
}

export const BrandHighlightCtaTracked: React.FC<
  React.PropsWithChildren<BrandHighlightCtaTrackedProps>
> = React.memo(function BrandHighlightCtaTracked({
  position,
  children,
  highlightId,
  highlightSlide,
}) {
  const track = useHighlightZoomSliderTracking();

  return (
    <div
      onClick={() =>
        track({
          slide: highlightSlide,
          highlightId,
          streamPosition: position,
        })('click')
      }
    >
      {children}
    </div>
  );
});
